import React, { Component } from "react"
import HeroSection from "./Hero-Section"
import SocialIcons from "../SocialIcons"
import VarietyShowSection from "./Variety-Show-Section"

import "./index.css"
import HomeSpotLightSection from "./Spot-Lights-Section"

class Home extends Component {
  render() {
    return (
      <React.Fragment>
        <HeroSection />
        <VarietyShowSection />
        <HomeSpotLightSection />
      </React.Fragment>
    )
  }
}

export default Home
